/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: 'ng-template[orbitTableCell]', standalone: false })
export class OrbitTableCellTemplateDirective {
	@Input('orbitTableCell') columnKey = '';
	constructor(public readonly template: TemplateRef<{ $implicit: unknown; row: unknown; value: unknown }>) {}
}

@Directive({ selector: 'ng-template[orbitTableHeader]', standalone: false })
export class OrbitTableHeaderTemplateDirective {
	@Input('orbitTableHeader') columnKey = '';
	constructor(public readonly template: TemplateRef<{ $implicit: unknown; column: unknown }>) {}
}

@Directive({ selector: 'ng-template[orbitTableFilter]', standalone: false })
export class OrbitTableFilterTemplateDirective {
	constructor(public readonly template: TemplateRef<unknown>) {}
}
